@if (isVisible()) {
  <div class="wait-screen-overlay" role="dialog" aria-modal="true" aria-labelledby="wait-screen-title" animate.leave="wait-screen-leave">
    <div class="wait-screen-card">
      @switch (status()) {
        @case ('PENDING') {
          <div class="analyzing-header">
            <div class="domain-pill">
              <i class="pi pi-globe"></i>
              <span>{{ domain() }}</span>
            </div>
            <div class="progress-bar" role="progressbar" [attr.aria-valuenow]="progressPercent()" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-fill" [style.width.%]="progressPercent()"></div>
            </div>
            <span class="progress-text">{{ progressPercent() }}%</span>
          </div>

          <div class="analyzing-checklist">
            <!-- 1. Crawling -->
            <div class="checklist-item" [class.done]="crawlState() === 'done'" [class.active]="crawlState() === 'in progress'">
              <span class="item-icon">
                @if (crawlState() === 'done') { <i class="pi pi-check"></i> }
                @else if (crawlState() === 'in progress') { <span class="spinner"></span> }
                @else { <span class="dot-empty"></span> }
              </span>
              <span class="item-label" [class.shimmer-text]="crawlState() === 'in progress'">Reading your website</span>
            </div>

            <!-- 2. Discovery -->
            <div class="checklist-item" [class.done]="discoveryState() === 'done'" [class.active]="discoveryState() === 'in progress'" [class.pending]="discoveryState() === 'waiting'">
              <span class="item-icon">
                @if (discoveryState() === 'done') { <i class="pi pi-check"></i> }
                @else if (discoveryState() === 'in progress') { <span class="spinner"></span> }
                @else { <span class="dot-empty"></span> }
              </span>
              <span class="item-label" [class.shimmer-text]="discoveryState() === 'in progress'">Researching your company</span>
            </div>

            <!-- 3. Generation -->
            <div class="checklist-item" [class.done]="generationState() === 'done'" [class.active]="generationState() === 'in progress'" [class.pending]="generationState() === 'waiting'">
              <span class="item-icon">
                @if (generationState() === 'done') { <i class="pi pi-check"></i> }
                @else if (generationState() === 'in progress') { <span class="spinner"></span> }
                @else { <span class="dot-empty"></span> }
              </span>
              <span class="item-label" [class.shimmer-text]="generationState() === 'in progress'">Writing playbook & ICP</span>
            </div>
          </div>

          <div class="actions center mt-4">
            <p-button label="Continue in background" severity="secondary" [text]="true" (click)="skip()"></p-button>
          </div>
        }

        @case ('FAILED') {
          <h2 id="wait-screen-title">{{ failureHeadline() }}</h2>
          @if (suggestedWebsite(); as suggestion) {
            <small class="field-hint">
              Did you mean
              <button type="button" class="link-button" (click)="useSuggestedWebsite()">{{ suggestion }}</button>?
            </small>
          }
          <div class="input-wrap mt-4">
            <i class="pi pi-globe"></i>
            <input
              type="text"
              pInputText
              pSize="large"
              class="full-width-input"
              placeholder="Company website"
              autocomplete="url"
              [ngModel]="website()"
              (ngModelChange)="website.set($event)"
              (keydown.enter)="retryWithWebsite()" />
          </div>
          <div class="actions center mt-4">
            <p-button label="Try again" [loading]="retrying()" [disabled]="!website().trim()" (click)="retryWithWebsite()"></p-button>
            <p-button label="Upload docs" severity="secondary" [text]="true" (click)="goManual()"></p-button>
          </div>
        }

        @default {
          <h2 id="wait-screen-title">Setting up your workspace</h2>
          <div class="actions center">
            <p-button label="Continue" (click)="continue()"></p-button>
          </div>
        }
      }
    </div>
  </div>
}
